// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const bulletBold = "List__bulletBold__REWOW";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const list = "List__list__o4E6C";
export const listItem = "List__listItem__NOKRR";
export const medium = "500";
export const orderedList = "List__orderedList__nTkIj";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const tableOfContents = "List__tableOfContents__xK7wo";
export const unorderedList = "List__unorderedList__eMUTr";